import styled, { withTheme } from 'styled-components'
import { Box } from 'rebass'

const SearchHero = styled(Box)`
  h3 {
    color: ${(props) => props.theme.colors.grey_light};
    font-weight: ${(props) => props.theme.weights[0]};
  }

  a {
    color: ${(props) => props.theme.colors.blue};
    font-weight: ${(props) => props.theme.weights[1]};
  }
`

export default withTheme(SearchHero)
